import Loading from "@components/layout/Loading";
import { useGetUser } from "@utils/hooks";
import FactFindIntro from "@view/fact_find/FactFindIntro";
import FactFindProgress from "@view/fact_find/FactFindProgress";
import React from "react";

type FactFindProps = {};

const FactFind: React.FC<FactFindProps> = () => {
  const { data: userData, isLoading: userDataLoading } = useGetUser();

  if (userDataLoading) {
    return <Loading />;
  }

  return userData?.form_qualification && userData?.is_tax_resident === "Yes" ? (
    <FactFindProgress
      progress={{
        personal_details: userData?.form_fact_find_personal_details,
        financial_details: userData?.form_fact_find_financial_details,
        risk_reward: userData?.form_fact_find_risk_reward,
      }}
    />
  ) : (
    <FactFindIntro />
  );
};
export default FactFind;
